import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DefaultCompanyService } from '../../services/default-company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { Select } from '@ngxs/store';
import { BaseSharedState } from '@shared-store/base.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'header-default-company',
  template: ` <a nz-dropdown [nzDropdownMenu]="menu" *ngIf="!isAdminUser">
      <div
        class="alain-default__nav-item d-flex align-items-center px-sm"
        nz-dropdown
        nzPlacement="bottomRight"
        class="bold com-sep"
      >
        {{ defaultCompany }}
      </div>
    </a>
    <nz-dropdown-menu #menu="nzDropdownMenu" nzPlacement="bottomRight">
      <div nz-menu class="width-sm" *ngIf="listCompanies.length > 1">
        <div *ngFor="let company of listCompanies" nzSelectable>
          <div nz-menu-item (click)="showConfirm(company)">
            {{ company.orgnaizationName }}
          </div>
        </div>
        <!-- <div nz-menu-divider></div>
      <div nz-menu-item  (click)="newRegistration();">New Register</div> -->
      </div>
    </nz-dropdown-menu>`,
  styles: [
    '.com-sep { border-right: solid 1px #909090;padding: 0 5px;display: inline; margin-right: 5px;}',
  ],
})
export class HeaderDefaultCompanyComponent implements OnInit,OnChanges {
  confirmModal: NzModalRef;
  listCompanies: any = [];
  orgnaizationName: string;
  defaultCompany: string | undefined;
  isAdminUser = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modal: NzModalService,
    private userInfoService: UserInfoService,
    private defaultCompanyService: DefaultCompanyService
  ) {}

  ngOnInit() {
    if (window.location.href.indexOf('admin-ui') >= 0 || window.location.href.indexOf('/intelligence-suite') >= 0 || window.location.href.indexOf('/inventory-ui') >= 0 ) {
      this.isAdminUser = true;
    } else {
      this.isAdminUser = false;
      if( this.userInfoService.getUserInfo()){
        this.getListofCompanies(this.userInfoService.getUserInfo().customerId);
        this.defaultCompany = this.userInfoService.getUserInfo().customerName;
      }else if(this.userInfoService.getUserInfo() == null){
        this.userInfoService.getUserInfo$().subscribe(() => {
          if (this.defaultCompany === undefined) {
            const user = this.userInfoService.getUserInfo();
            if(user && user.customerId) {
              this.getListofCompanies(user.customerId);
              this.defaultCompany = user.orgnaizationName;
            }
          }
        });
      }
      console.log('default co =>', this.defaultCompany, this.userInfoService.getUserInfo());
    }
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  getListofCompanies(customerId: any) {
    this.defaultCompanyService
      .listCompanies(customerId)
      .subscribe((result: any) => {
        if (result && result?.content?.length > 0) {
          this.listCompanies = result.content;
          if (result.content.length > 0) {
            this.userInfoService.updateUserDefaultCompany(result.content[0]);
          }
          if (this.defaultCompany) {
            const selectedCompany = result.content.find(
              (item: any) => item.orgnaizationName === this.defaultCompany
            );
            this.userInfoService.updateUserDefaultCompany(selectedCompany);
          }
        } else {
          this.listCompanies = [];
        }
      });
  }

  showConfirm(data: any): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: 'Set default company to ' + data.orgnaizationName,
      nzContent:
        'When clicked the OK button, the default company will set to  ' +
        data.orgnaizationName,
      nzOnOk: () =>
        new Promise((resolve, reject) => {
          this.userInfoService.updateUserDefaultCompany(data);
          this.defaultCompany = data.orgnaizationName;
          this.defaultCompanyService
            .setDefaultCompany(data, data.loginId, data.customerId)
            .subscribe(() => {
              this.router.navigateByUrl('/app/landing');
            });
          setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log('errors!')),
    });
  }
}
